import request from '@utils/request';

// 初始化活动
export const init = params => request.post('/growth/lottery/init', params);

// 登录接口
export const login = params => request.post('/growth/lottery/login', params);

// 获取奖品库存
export const getstock = params => request.post('/growth/lottery/getstock', params);

// 获取用户奖品列表
export const getgiftinfo = params => request.post('/growth/lottery/getgiftinfo', params);

// 抽奖
export const lucky = params => request.post('/growth/lottery/lucky', params);

// 提交中奖用户信息
export const submituserinfo = params => request.post('/growth/lottery/setgiftaddress', params);
// 第三方埋点
export const trackData = params => request.post('/external/advertisingaccess/conversion', params);
// 生成短链跳微信小程序
export const shortUrl = params => request.post('/external/advertisingaccess/getshorturl', params);
